$(document).ready(function () {
  if ($(".video-player-section").length) {
    $(".video-selector").click(function () {
      changeSelectedVideo($(this));
    });

    var isDesktop = ($(window).width() > breakpoints.xsmall);

    $(window).resize(function () {
      if ($(window).width() > breakpoints.xsmall && !isDesktop) {
        $(".mobile-iframe").each(function() {
          var src= $(this).attr('src');
          $(this).attr('src', src);
        });
        isDesktop = true;
      }

      if ($(window).width() <= breakpoints.xsmall && isDesktop) {
        $(".desktop-iframe").each(function() {
          var src= $(this).attr('src');
          $(this).attr('src', src);
        });
        isDesktop = false;
      }
    });
  }
});

function changeSelectedVideo($selection) {
  if (!$selection.hasClass("active")) {
    var selectedUrl = $selection.data("video-src");
    var $selectedTitle = $selection.find(".title");
    var $videoPlayerSection = $selection.closest(".desktop-video-players");
    var $videoSelectors = $videoPlayerSection.find(".video-selector");

    // Make active selector and change title
    $videoPlayerSection.find(".video-selector").removeClass("active");
    $videoSelectors.each(function () {
      $(this).removeClass("active");
      var $selectorTitle = $(this).find(".title");
      $selectorTitle.text($selectorTitle.data("title"));
    });
    $selection.addClass("active");
    $selection.find(".title").text("Now Playing");

    // Change player title and source.
    $videoPlayerSection.find(".video-player-title").text($selectedTitle.data("title"));
    $videoPlayerSection.find(".video-player").find("iframe").attr("src", selectedUrl);
  }
}